type TProps = {
  overlay?: boolean;
  className?: string;
};

export const RelativeSpinner = ({ overlay = false, className = 'relative-spinner' }: TProps) => {
  const spinnerWrapperClassName = overlay
    ? 'relative-spinner-wrapper absolute left-1/2 top-1/2 z-[101] -translate-x-1/2 -translate-y-1/2 [&_svg]:animate-spin'
    : 'relative-spinner-wrapper absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 [&_svg]:animate-spin';

  return (
    <div className={[overlay ? 'h-full w-full' : '', className].filter(Boolean).join(' ')}>
      {overlay ? (
        <div className="spinner-overlay absolute z-[100] h-full w-full bg-[var(--color-spinner-overlay)]" />
      ) : null}
      <div className={spinnerWrapperClassName}>
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM30 55C43.8071 55 55 43.8071 55 30C55 16.1929 43.8071 5 30 5C16.1929 5 5 16.1929 5 30C5 43.8071 16.1929 55 30 55Z"
            fill="var(--color-spinner-track)"
          />
          <circle
            cx="30"
            cy="30"
            r="27.5"
            stroke="var(--color-spinner-gradient-end)"
            strokeDasharray="21.6 151.2"
            strokeWidth="5"
            transform="rotate(-90 30 30)"
          />
        </svg>
      </div>
    </div>
  );
};
